const initialState = {
  all: {
    data: null,
    get: {
      error: null,
      loading: false,
    },
  },
};

export default function filters(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    // GET FILTERS
    case 'FILTERS_GET_ALL_REQUEST':
      return {
        ...state,
        all: {
          ...state.all,
          get: {
            error: null,
            loading: true,
          },
        },
      };

    case 'FILTERS_GET_ALL_SUCCESS':
      return {
        ...state,
        all: {
          ...state.all,
          data: payload,
          get: {
            error: null,
            loading: false,
          },
        },
      };

    case 'FILTERS_GET_ALL_FAILURE':
      return {
        ...state,
        all: {
          ...state.all,
          get: {
            error: payload,
            loading: false,
          },
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/filters.js